<template>
	<div>
		<div v-if="!isMobile && sellerListings">
			<Header />
			<TitlePage />
			<div class="content-seller-detail">
				<b-container fluid="xl">
					<b-row>
						<div class="wrap-info" v-if="sellerListings">
							<ul class="ul-wrap-info">
								<li class="info-item">
									<b-avatar
										:size="80"
										class="bg-transparent"
										:src="
											sellerListings.user && sellerListings.user.profile_image
												? sellerListings.user.profile_image
												: '/images/avatar.png'
										"
									></b-avatar>
								</li>
								<li class="info-item">
									<span class="name">{{
										sellerListings.user ? sellerListings.user.display_name : ''
									}}</span>
									<br />
									<span class="title">{{ $t('user.email') }}</span>
									<br />
									<span class="email"
										><a
											:href="
												sellerListings.user && sellerListings.user.email
													? `mailto:${sellerListings.user.email}`
													: ''
											"
											>{{
												sellerListings.user ? sellerListings.user.email : ''
											}}</a
										></span
									>
								</li>
								<li class="info-item">
									<span class="title">{{ $t('user.phoneNumber') }}</span>
									<br />
									<span class="phone">{{
										sellerListings.user && sellerListings.user.telephone
											? sellerListings.user.telephone
											: '--'
									}}</span>
								</li>
								<li class="info-item">
									<span class="title">{{ $t('line') }}</span>
									<br />
									<span class="phone">
										<a
											:href="
												sellerListings.user && sellerListings.user.line_id
													? `http://line.me/ti/p/${sellerListings.user.line_id}`
													: 'javacript:void(0)'
											"
											target="_blank"
										>
											{{
												sellerListings.user && sellerListings.user.line_id
													? sellerListings.user.line_id
													: '--'
											}}
										</a>
									</span>
								</li>
								<li class="info-item">
									<span class="title">{{ $t('user.alllistings') }}</span>
									<br />
									<span class="listings"
										>{{
											sellerListings.meta && sellerListings.meta.itemCount
												? sellerListings.meta.itemCount
												: 0
										}}
										{{ $t('sellerDetail.listing') }}</span
									>
								</li>
							</ul>
							<div class="line-bottom"></div>
						</div>
						<b-col cols="12" class="seller-detail-card">
							<b-row>
								<b-col cols="12" class="pd-0">
									<div class="wrapper" v-if="sellerListings.listings">
										<div
											class="item"
											v-for="(listing, key) in sellerListings.listings"
											:key="key"
										>
											<Card
												:color="'bg-yellow'"
												:showNegotiable="true"
												:price="listing.price"
												:title="listing.title"
												:province="listing.province.name"
												:district="listing.district.name"
												:urlImage="listing.url_feature_image"
												:id="listing.id"
												:listingPremium="listing.listing_premiums"
												:fav="parseInt(listing.fav) == 0 ? false : true"
												:agency_profile_image="listing.agency_profile_image"
												:url="listing.url"
											/>
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row cols="12" lg="12" class="text-center paginate-position">
								<div class="overflow-auto wrap-pagination d-none d-md-block">
									<b-pagination-nav
										v-model="page"
										class="paginate-item"
										:prev-text="$t('nextPg')"
										:next-text="$t('prevPg')"
										:link-gen="paginationNumber"
										:number-of-pages="
											sellerListings.meta && sellerListings.meta.pageCount
												? sellerListings.meta.pageCount
												: 1
										"
										use-router
									></b-pagination-nav>
								</div>
							</b-row>
						</b-col>
					</b-row>
				</b-container>
			</div>
			<Footer :adsFooter="adsFooter" />
		</div>

		<div v-if="isMobile">
			<Header />
			<TitlePage />
			<div class="content-seller-detail mb-content-seller-detail">
				<b-container fluid="xl">
					<b-row>
						<b-col cols="12" class="text-center">
							<div class="seller-img"></div>
							<b-avatar
								:size="88"
								class="bg-transparent"
								:src="
									sellerListings.user && sellerListings.user.profile_image
										? sellerListings.user.profile_image
										: '/images/avatar.png'
								"
							></b-avatar>
							<div class="seller-name">
								{{
									sellerListings.user ? sellerListings.user.display_name : ''
								}}
							</div>
						</b-col>
						<b-col cols="12">
							<div class="info">
								<div class="wrap-text">
									<EmailIcon />
									<div class="wrapper">
										<div class="text">{{ $t('user.email') }}</div>
										<div class="text">
											<a
												style="color:var(--projectPrimaryColor)"
												:href="
													sellerListings.user && sellerListings.user.email
														? `mailto:${sellerListings.user.email}`
														: ''
												"
												>{{
													sellerListings.user ? sellerListings.user.email : ''
												}}</a
											>
										</div>
									</div>
								</div>
								<a
									:href="
										sellerListings.user && sellerListings.user.telephone
											? `tel:${sellerListings.user.telephone}`
											: 'javacript:void(0)'
									"
								>
									<div class="wrap-text">
										<PhoneForwardIcon />
										<div class="wrapper">
											<div class="text">{{ $t('user.phoneNumber') }}</div>
											<div class="text">
												{{
													sellerListings.user && sellerListings.user.telephone
														? sellerListings.user.telephone
														: '--'
												}}
											</div>
										</div>
									</div>
								</a>
								<a
									:href="
										sellerListings.user && sellerListings.user.line_id
											? `http://line.me/ti/p/${sellerListings.user.line_id}`
											: 'javacript:void(0)'
									"
									target="_blank"
								>
									<div class="wrap-text">
										<img
											src="/images/line.png"
											style="width: 35px;height:35px; margin-right: 10px;"
											:alt="
												$t('sellerDetail.thairathTrading', {
													affiliate: $root.affiliate
												})
											"
										/>
										<div class="wrapper">
											<div class="text">{{ $t('line') }}</div>
											<div class="text">
												{{
													sellerListings.user.line_id
														? sellerListings.user.line_id
														: '--'
												}}
											</div>
										</div>
									</div>
								</a>
							</div>
						</b-col>
						<b-col cols="12">
							<div class="wrap-listing">
								<div class="text number-listing">
									{{ $t('user.alllistings') }}
									{{
										sellerListings.meta && sellerListings.meta.itemCount
											? sellerListings.meta.itemCount
											: 0
									}}
									{{ $t('user.listing') }}
								</div>
								<div class="wrapper" v-if="sellerListings.listings">
									<div
										class="item"
										v-for="(listing, key) in sellerListings.listings"
										:key="key.id"
									>
										<Card
											:color="'bg-yellow'"
											:showNegotiable="true"
											:price="listing.price"
											:title="listing.title"
											:province="listing.province.name"
											:district="listing.district.name"
											:urlImage="listing.url_feature_image"
											:id="listing.id"
											:listingPremium="listing.listing_premiums"
											:fav="parseInt(listing.fav) == 0 ? false : true"
											:agency_profile_image="listing.agency_profile_image"
											:url="listing.url"
										/>
									</div>
								</div>
								<infinite-loading
									@infinite="infiniteHandler"
									ref="infiniteHandler"
								>
									<span slot="no-results"
										><b-alert
											show
											variant="light"
											v-if="
												sellerListings.listings &&
													!sellerListings.listings.length
											"
											>{{ $t('userDashboard.messages.emptyData') }}</b-alert
										></span
									>
									<span slot="no-more"></span>
								</infinite-loading>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '@/components/ui/header';
import Footer from '@/components/ui/footer';
import TitlePage from '@/components/ui/titlePage';
import Card from '@/components/card';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import PhoneForwardIcon from '@/components/icons/IconPhoneForward/index';
import InfiniteLoading from 'vue-infinite-loading';
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
	name: 'sellerDetail',
	components: {
		Header,
		Footer,
		TitlePage,
		Card,
		EmailIcon,
		PhoneForwardIcon,
		InfiniteLoading
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('SellerController', ['sellerListings'])
	},
	data() {
		return {
			page: 1, //this.$route.params.id ? this.$route.params.id : 1,
			limit: 12,
			adsFooter: null
		};
	},
	created() {
		if (this.$route.fullPath.includes('page')) {
			this.$router.replace(
				this.$i18nRoute({ name: 'seller-detail' }, this.$route.params.id)
			);
		}
		this.getSellerListings();
		let locationId = 9;
		if (this.isMobile) {
			locationId = 49;
		}
		this.getFooterAds(locationId);
	},
	watch: {
		page: function(val) {
			// Call api for Desktop
			if (!this.isMobile) {
				this.getSellerListings();
			}
		}
		// sellerListings: function(arr) {
		//
		//   this.sellerListings = JSON.parse(JSON.stringify(arr));
		//
		// }
	},
	methods: {
		...mapActions('SellerController', ['GET_SELLER_LISTING']),
		...mapActions('AdsController', [
			'GETADS_FOR_PUBLIC_WEBSITE',
			'CLICK_BANNERADS'
		]),
		// Call api for Mobile,
		getSellerListings() {
			this.GET_SELLER_LISTING({
				take: this.limit,
				page: this.page,
				id: this.$route.params.id
			});
		},
		async infiniteHandler($state) {
			this.GET_SELLER_LISTING({
				isMobile: true,
				take: this.limit,
				page: this.page,
				id: this.$route.params.id
			}).then(response => {
				if (!response.data.data) {
					return $state.complete();
				}
				let arrLength = response.data.data.listings.length;
				if (arrLength > 0) {
					this.page += 1;
					$state.loaded();
				} else $state.complete();
			});
		},
		paginationNumber(pageNum) {
			return pageNum === 1 ? '?' : `?page=${pageNum}`;
		},
		getFooterAds(locationId) {
			console.log('locationId', locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				console.log('data', data);
				if (data) {
					this.adsFooter = data;
					this.$forceUpdate();
				}
			});
		}
	},
	destroyed() {
		console.log('destroyed search');
		this.adsFooter = null;
	}
};
</script>
<style lang="scss">
@import 'style';
</style>
